import unregisterEndpoint from 'mini-webpush-notifications/lib/services/unregisterEndpoint';
import { default as registerEndpoint } from 'mini-webpush-notifications/lib/services/registerEndpoint';
import { listenMessageFromExtension } from './listenMessageFromExtension';
import { MessageResponseTypes } from '../schema/ResponseMessageTypes';

export const initializePushSubscriptionDataListener = () => {
    listenMessageFromExtension(event => {
        if (event.data.type !== MessageResponseTypes.PushSubscriptionData) {
            return;
        }

        const json = JSON.parse(event.data.payload);
        registerEndpoint(json)
            .then(registered => {
                // tslint:disable-next-line:no-console
                console.log('registered: ', registered);
            })
            .catch(e => {
                // tslint:disable-next-line:no-console
                console.error(e);
            });
    });

    listenMessageFromExtension(event => {
        if (event.data.type == MessageResponseTypes.UnsubscribeOwaPush) {
            unregisterEndpoint(event.data.payload.endPoint, event.data.payload.clientId);
        }
    });
};
